<template>
    <div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="pswp__bg"></div>

        <div class="pswp__scroll-wrap">
            <div class="pswp__container">
                <div class="pswp__item"></div>
                <div class="pswp__item"></div>
                <div class="pswp__item"></div>
            </div>

            <div class="pswp__ui pswp__ui--hidden">
                <div class="pswp__top-bar">
                    <div class="pswp__counter"></div>

                    <button
                        class="pswp__button pswp__button--close"
                        :title="$t('common:closeEsc')"
                    ></button>

                    <button
                        class="pswp__button pswp__button--share"
                        :title="$t('common:share')"
                    ></button>

                    <button
                        class="pswp__button pswp__button--fs"
                        :title="$t('common:toggleFullscreen')"
                    ></button>

                    <button
                        class="pswp__button pswp__button--zoom"
                        :title="$t('common:zoomInOut')"
                    ></button>

                    <div class="pswp__preloader">
                        <div class="pswp__preloader__icn">
                            <div class="pswp__preloader__cut">
                                <div class="pswp__preloader__donut"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap"
                >
                    <div class="pswp__share-tooltip"></div>
                </div>

                <button
                    class="pswp__button button-prev iconfont icon-prev"
                    :title="$t('common:previousArrowLeft')"
                    @click="prev"
                ></button>

                <button
                    class="pswp__button button-next iconfont icon-prev"
                    :title="$t('common:nextArrowRight')"
                    @click="next"
                ></button>

                <div class="pswp__caption">
                    <div class="pswp__caption__center"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import util from '../common/util.js';
export default {
    props: {
        options: {
            type: Object,
            required: true
        },
        defaultSize: {
            type: String,
            required: true
        },
        trackSource: {
            type: String,
            default: ''
        }
    },
    created() {
        if (!util.isSSRServer) {
            this.prepare();
        }

        this.imgSizes = {};
    },
    mounted() {
        document.body.appendChild(this.$el);
    },
    unmounted() {
        this.$el.remove();
    },
    methods: {
        updateImgSize(index, width, height) {
            this.imgSizes[index] = { width: width, height: height };
            if (this.gallery) {
                this.gallery.items[index].w = width;
                this.gallery.items[index].h = height;
                if (this.gallery.items[index].loaded) {
                    this.gallery.updateSize(true);
                }
            }
        },
        parseThumbnailElements() {
            let items = [];
            for (var i = 0; i < this.options.images.length; i++) {
                let size;
                if (this.imgSizes[i]) {
                    size = this.imgSizes[i];
                } else {
                    let s = this.defaultSize.split('x');
                    size = { width: +s[0], height: +s[1] };
                }
                var imgSrc = this.options.images[i]?.preview
                    ? this.options.images[i].preview
                    : this.options.images[i];
                let item = {
                    src: imgSrc,
                    w: size.width,
                    h: size.height,
                    el: this.options.elems[i]
                };
                items.push(item);
            }
            return items;
        },
        openPhotoSwipe(index, elem) {
            this.prepare().then(() => {
                this._openPhotoSwipe(index, elem);
            });
        },
        _openPhotoSwipe(index) {
            window.siteAppVm.$EventBus.$emit('siteTrack', {
                trackType: 'image-view',
                action: 'view',
                category: this.trackSource
            });
            let items = this.parseThumbnailElements();

            let options = {
                closeEl: true,
                captionEl: true,
                fullscreenEl: false,
                zoomEl: false,
                shareEl: false,
                tapToClose: true,
                counterEl: true,
                arrowEl: true,
                preload: [3, 3],
                bgOpacity: 1,
                history: false,
                preloaderEl: true,
                indexIndicatorSep: ' of ',

                getThumbBoundsFn: function(index) {
                    let elem = items[index].el;
                    let pageYScroll =
                            window.pageYOffset ||
                            document.documentElement.scrollTop,
                        rect = elem.getBoundingClientRect();

                    return {
                        x: rect.left,
                        y: rect.top + pageYScroll,
                        w: rect.width
                    };
                }
            };

            options.index = index;

            this.gallery = new window.PhotoSwipe(
                this.$el,
                window.PhotoSwipeUI_Default,
                items,
                options
            );
            this.gallery.init();

            this.gallery.listen('unbindEvents', () => {
                window.siteAppVm.$EventBus.$emit('siteTrack', {
                    trackType: 'image-view-end',
                    category: this.trackSource
                });
                // var getCurrentIndex = this.gallery.getCurrentIndex();
                // //  Compatible details page
                // getCurrentIndex = Math.floor(
                //     getCurrentIndex / this.options.swiperNum
                // );
                // if (this.options.mySwiper && !this.options.stay)
                //     this.options.mySwiper.slideTo(getCurrentIndex, 0, true);
            });
        },
        prepare() {
            if (!this.ps) {
                var cssPs = util.addStyle(
                    '//static.chimeroi.com/lib/photoswipe/photoswipe.css'
                );
                var cssPs1 = util.addStyle(
                    '//static.chimeroi.com/lib/photoswipe/default-skin.css'
                );
                var scriptPs = util.addScript(
                    '//static.chimeroi.com/lib/photoswipe/photoswipe.min.js'
                );
                var scriptPs1 = util.addScript(
                    '//static.chimeroi.com/lib/photoswipe/photoswipe-ui-default.min.js'
                );
                this.ps = Promise.all([cssPs, cssPs1, scriptPs, scriptPs1]);
            }
            return this.ps;
        },
        prev() {
            this.gallery.prev();
            window.siteAppVm.$EventBus.$emit('siteTrack', {
                trackType: 'image-view',
                action: 'view',
                category: this.trackSource
            });
        },
        next() {
            this.gallery.next();
            window.siteAppVm.$EventBus.$emit('siteTrack', {
                trackType: 'image-view',
                action: 'view',
                category: this.trackSource
            });
        }
    }
};
</script>
<style lang="scss">
@import '../theme/media.scss';
@mixin pswp__button--arrow {
    color: #fff;
    font-size: 36px;
    background-image: none !important;
    width: 50px;
    height: 50px;
    line-height: 50px;
}

.pswp {
    display: none;
    &.pswp--open {
        display: block;
        .pswp__ui--idle .pswp__top-bar,
        .pswp__bg {
            opacity: 1;
            background: rgba(0, 0, 0, 0.8);
            @media (max-width: 600px) {
                background: rgba(0, 0, 0, 0.9);
            }
        }
    }
    .pswp__top-bar,
    .pswp__item {
        cursor: zoom-out;
    }
    .pswp__preloader {
        cursor: default;
        position: relative;
        left: auto;
        top: auto;
        margin: 0;
        float: right;
    }
    .pswp__counter {
        cursor: default;
        left: 50%;
        transform: translateX(-50%);
    }

    // .button-prev,
    // .button-next {
    //     transition: opacity 333ms cubic-bezier(0.4, 0, 0.22, 1);
    //     top: 50%;
    //     margin-top: -50px;
    //     width: 70px;
    //     height: 100px;
    //     position: absolute;
    // }
    // .button-next {
    //     right: 40px;
    //     @include pswp__button--arrow;
    //     &::before {
    //         transform: rotate(180deg);
    //     }
    // }
    // .button-prev {
    //     left: 40px;
    //     @include pswp__button--arrow;
    //     &::before {
    //     }
    // }
    .button-prev,
    .button-next {
        position: absolute;
        width: 40px;
        height: 100px;
        background: #1b1b1b;
        opacity: 0.5;
        top: 50%;
        background-image: none !important;
        transform: translateY(-50%);
        font-size: 20px;
        color: #fff;
        text-align: center;
        line-height: 100px;
        cursor: pointer;
        z-index: var(--level-low);
        &:hover {
            opacity: 0.7;
        }
        &.swiper-button-disabled {
            display: none;
        }
    }
    .button-prev {
        left: 0;
        border-radius: 0px 10px 10px 0px;
    }
    .button-next {
        right: 0;
        border-radius: 10px 0 0 10px;
        &::before {
            transform: rotate(180deg);
            display: block;
        }
    }
    .pswp__ui--one-slide {
        .button-prev,
        .button-next {
            display: none;
        }
    }
}
@include media-600 {
    .pswp__button.button-next,
    .pswp__button.button-prev {
        display: none;
    }
}
.pswp__ui--idle {
    .button-prev,
    .button-next {
        opacity: 0;
    }
}

.mfp-container {
    padding: 0;
    overflow: hidden;
    img.mfp-img {
        padding: 0;
    }
    .mfp-counter {
        right: 8px;
    }
}

.pops.detail-banner .icon-close::before {
    color: #fff;
}
</style>
